import React from "react";

const DontAttend = () => {
  return (
    <div className="container">
      <div className="attend">
        <h1>I'm sorry you wont come to my party!</h1>
      </div>
    </div>
  );
};

export default DontAttend;
